module.exports = __webpack_public_path__ + "static/img/8.44ba751.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/8.png
// module id = 2YBj
// module chunks = 0